import { connect } from 'react-redux';
import View from './HomeEstimatedValueView';
import { updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import {
  nullableMarketValueSelector,
  homeEstimatedValueIsValidSelector,
} from './HomeEstimatedValueSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';
import isHomePurchaseGoalValidSelector from '../../HomePurchaseWorkflowSelector';
import nullableDownPaymentSelector from '../../../MortgageWorkflow/Steps/DownPayment/DownPaymentSelector';
import { nullableHasPlanToGetMortgageSelector } from '../../../MortgageWorkflow/Steps/PlanToGetMortgage/PlanToGetMortgageSelector';

const mapStateToProps = (state, ownProps) => ({
  workflowId: ownProps.workflowId,
  homeEstimatedValue: nullableMarketValueSelector(state, ownProps),
  nullableDownPayment: nullableDownPaymentSelector(state, ownProps),
  homeEstimatedValueIsValid: homeEstimatedValueIsValidSelector(state, ownProps),
  doNotSave: !isHomePurchaseGoalValidSelector(state, ownProps),
  nullableHasPlanToGetMortgage: nullableHasPlanToGetMortgageSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  stepValidator: homeEstimatedValueIsValid => () => {
    if (!homeEstimatedValueIsValid) {
      return ['Please specify a valid value.'];
    }
    return [];
  },
  onChangeHomeEstimatedValue: workflowId => ({ target: { value } }) => {
    let MarketValue = null;
    if (value !== '') {
      MarketValue = +value;
    }
    dispatch(updateData(
      {
        [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
          MarketValue,
        },
      },
      workflowId,
    ));
  },
  onPostProcess: (nullableDownPayment, nullableHasPlanToGetMortgage) => (data) => {
    let DownPayment = nullableDownPayment;
    const { MarketValue } = data[HOME_PURCHASE_GOAL_GRAPH_NODE];
    if (nullableHasPlanToGetMortgage === true && MarketValue !== null) {
      if (DownPayment !== null) {
        DownPayment = Math.min(nullableDownPayment, MarketValue);
      }
    } else {
      DownPayment = MarketValue;
    }

    return {
      ...data,
      [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
        ...data[HOME_PURCHASE_GOAL_GRAPH_NODE],
        DownPayment,
      },
    };
  },
  onPostSave: workflowId => (data) => {
    dispatch(updateData(data, workflowId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
